type ErrorWithStatus = { status?: unknown };

const NON_RETRYABLE_QUERY_STATUSES = new Set([401, 403, 404]);

export function shouldRetryQuery(
  failureCount: number,
  error: unknown,
): boolean {
  const status =
    typeof error === "object" && error !== null
      ? (error as ErrorWithStatus).status
      : undefined;
  if (typeof status === "number" && NON_RETRYABLE_QUERY_STATUSES.has(status)) {
    return false;
  }
  return failureCount < 1;
}
